<template>
  <div>
    <v-form v-model="isFormValid">
      <h2>運営アカウント設定</h2>

      <v-progress-linear v-if="isLoading" indeterminate />

      <v-container class="mt-4">
        <v-row align="center">
          <v-col cols="6">
            <h5>法人名*</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.companyName"
              :rules="[required]"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6">
            <h5>郵便番号</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.postalCode"
              prefix="〒"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6">
            <h5>都道府県</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.prefecture"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6">
            <h5>市区町村番地</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.address"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6">
            <h5>建物・部屋番号</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.building"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6">
            <h5>電話番号</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.phoneNumber"
              :rules="[isTel]"
              label="ハイフンあり"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6">
            <h5>FAX</h5>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="inputValue.faxNumber"
              :rules="[isTel]"
              label="ハイフンあり"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="6">
            <h5>代表者*</h5>
          </v-col>
          <v-col cols="6">
            <v-select
              :items="userItems"
              v-model="inputValue.representativeUserId"
              :rules="[required]"
              variant="outlined"
              hide-details=""
              density="compact"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>

      <div class="d-flex justify-center mt-6">
        <v-btn
          @click="updateCompany"
          :disabled="!isFormValid || isLoading"
          color="primary"
          large
          depressed
          >保存</v-btn
        >
      </div>
    </v-form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { PutCompanyRequest } from "@/api/ApiCompany";
import ValidationMixin from "@/mixins/ValidationMixin";
import LocalDataService from "@/service/LocalDataService";
import { companyModule } from "@/store/dataModule/companyModule";
import { userModule } from "@/store/dataModule/userModule";
import { OperationCompanyResponse } from "chaild-api/lib";

export default defineComponent({
  mixins: [ValidationMixin],

  async mounted() {
    await this.getCompany();
    await this.listUsers();
  },

  data() {
    return {
      isLoading: false,
      isFormValid: false,
      inputValue: {} as PutCompanyRequest,
    };
  },

  computed: {
    userItems: function () {
      if (userModule.users) {
        const items = userModule.users.map((u) => {
          return {
            title: u.lastName + u.firstName,
            value: u.userId,
          };
        });
        return items;
      }
      return [];
    },
    company: function (): OperationCompanyResponse | null {
      return companyModule.company;
    },
  },

  methods: {
    async getCompany() {
      this.isLoading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId) {
        const response = await companyModule.getCompany({
          companyId: companyId,
        });
        if (response) {
          this.inputValue = response as any;
          (this.inputValue as any).representativeUserId = response.representative?.userId as any;
        }
      }
      this.isLoading = false;
    },
    async listUsers() {
      this.isLoading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId) {
        await userModule.listUsers({
          companyId: companyId,
        });
      }
      this.isLoading = false;
    },
    async updateCompany() {
      this.isLoading = true;
      if (this.inputValue && this.inputValue.companyId) {
        await companyModule.updateCompany(this.inputValue);
        await this.getCompany();
      }
      this.isLoading = false;
    },
  },
});
</script>
